import React from 'react';
import { UserCheck } from 'lucide-react';
import FormModalLayout from '../Common/FormModalLayout';
import Can from '../Common/Can';
import { P } from '../../constants/permissions';

const TechnicalResponsibleModal = ({ responsible, persons = [], councils = [], onSubmit, onClose }) => {
  const [formData, setFormData] = React.useState({
    person_id: responsible?.person_id || '',
    professional_council_id: responsible?.professional_council_id || '',
    professional_license_number: responsible?.professional_license_number || responsible?.registration_number || '',
    status: responsible?.is_active === false ? 'INACTIVE' : 'ACTIVE',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <FormModalLayout
      title={responsible ? 'Editar responsável técnico' : 'Novo responsável técnico'}
      subtitle="Profissional habilitado vinculado a conselho e registro."
      headerIcon={UserCheck}
      onClose={onClose}
      size="md"
      historyEntityType="technical_responsibles"
      historyEntityId={responsible?.id}
      footer={
        <>
          <button type="button" onClick={onClose} className="btn btn-outline">
            Cancelar
          </button>
          <Can permission={P.PROFESSIONAL_ACCESS}>
            <button type="submit" form="tech-resp-modal-form" className="btn btn-primary">
              {responsible ? 'Atualizar' : 'Criar'}
            </button>
          </Can>
        </>
      }
    >
      <form id="tech-resp-modal-form" onSubmit={handleSubmit} className="form-stack">
        <div className="form-group">
          <label htmlFor="tr-person" className="form-label form-label-required">
            Pessoa
          </label>
          <select
            id="tr-person"
            name="person_id"
            value={formData.person_id}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="">Selecione a pessoa</option>
            {persons.map((person) => (
              <option key={person.id} value={person.id}>
                {person.name || person.id}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="tr-reg" className="form-label form-label-required">
            Número de registro
          </label>
          <input
            id="tr-reg"
            type="text"
            name="professional_license_number"
            value={formData.professional_license_number}
            onChange={handleChange}
            className="form-input"
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="tr-council" className="form-label form-label-required">
            Conselho
          </label>
          <select
            id="tr-council"
            name="professional_council_id"
            value={formData.professional_council_id}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="">Selecione o conselho</option>
            {councils.map((council) => (
              <option key={council.id} value={council.id}>
                {council.acronym ? `${council.acronym} — ${council.name}` : council.name}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label htmlFor="tr-status" className="form-label">
            Status
          </label>
          <select
            id="tr-status"
            name="status"
            value={formData.status}
            onChange={handleChange}
            className="form-select"
          >
            <option value="ACTIVE">Ativo</option>
            <option value="INACTIVE">Inativo</option>
          </select>
        </div>
      </form>
    </FormModalLayout>
  );
};

export default TechnicalResponsibleModal;
